import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { initialFormData } from "./InitailState";
import DatePicker from "react-datepicker";

import {
  fetchData,
  fetchFormData,
  getTodayDate,
  getValueLabel,
  YearformatDate,
  leadPriorityData,
} from "../../utils/options";
import topTost from "../../utils/topTost";
import MultiSelectTags from "../shared/MultiSelectTags";
import TextArea from "../shared/TextArea";

const Loan_InquiryCreate = ({ permission }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const { id } = useParams();
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];

  const [formInquiryData, setFormInquiryData] = useState({
    inquiry_date: today,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stateData, setStateData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [citydata, setCityData] = useState([]);
  const [LoanTypedata, setLoanTypeData] = useState([]);
  const [lead_sourcedata, setLead_sourceData] = useState([]);
  // const [leadPriorityData, setLeadPriorityData] = useState([]);
  const [bankdata, setBankData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [userData, setUserData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleChange = (name, value) => {
    setFormInquiryData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (userId && !formInquiryData.assigned_to) {
      setFormInquiryData((prev) => ({
        ...prev,
        assigned_to: parseInt(userId), // assuming IDs are numeric
      }));
    }
  }, [userId]);

  const fetchAllData = async () => {
    const userId = localStorage.getItem("id");

    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    const branchData = await fetchFormData(
      "list-loan-types-Dropdown",
      formData,
      "POST"
    );
    const stateData = await fetchData("active-states", {}, "POST");
    const statusData = await fetchData(
      "loan-inquiry-statusesDrop",
      formData,
      "POST"
    );
    const userData = await fetchFormData(
      "get-employees-listuserdrop",
      formData,
      "POST"
    );
    const lead_sourceData = await fetchFormData(
      "lead-sources-listdrop",
      formData,
      "POST"
    );

    // const leadPriority_Data = await fetchFormData(
    //   "list-lead-prioritiesdropdown",
    //   formData,
    //   "POST"
    // );

    const bankData = await fetchData("getallbank", {}, "GET");

    // Handle Branch Data
    if (branchData) {
      const branches = branchData.data;
      setLoanTypeData(getValueLabel(branches, "loan_type_name", "id") || []);
    }

    // Handle State Data
    if (stateData) {
      const states = stateData.states;
      setStateData(getValueLabel(states, "state_title", "state_id") || []);
    }
    if (statusData) {
      const status = statusData.states;
      setStatusData(getValueLabel(status, "loan_inquiry_status", "id") || []);
    }
    if (userData) {
      const user = userData.users;
      setUserData(getValueLabel(user, "name", "id") || []);
    }
    if (lead_sourceData) {
      const user = lead_sourceData.data;
      setLead_sourceData(getValueLabel(user, "source_name", "id") || []);
    }
    if (bankData) {
      const user = bankData.data;
      setBankData(getValueLabel(user, "lender_name", "id") || []);
    }
  };

  const fetchDistrictData = async (stateId) => {
    const result = await fetchData(`districts/${stateId}`, {}, "POST");

    if (result) {
      const districts = result.districts;
      setDistrictData(
        getValueLabel(districts, "district_title", "district_id") || []
      );
    }
  };
  const fetchCityData = async (districtId) => {
    const result = await fetchData(`cities/${districtId}`, {}, "POST");

    if (result) {
      const cities = result.cities;
      setCityData(getValueLabel(cities, "city_title", "city_id") || []);
    }
  };

  const handleStateChange = (selectedState) => {
    if (selectedState) {
      const stateId = selectedState.value;

      setFormInquiryData((prevData) => ({
        ...prevData,
        state: stateId,
        district: "",
        city: "",
      }));

      setDistrictData([]);
      setCityData([]);
      fetchDistrictData(stateId);
    }
  };

  const handleDistrictChange = (selectedDistrict) => {
    if (selectedDistrict) {
      const districtId = selectedDistrict.value;
      console.log(selectedDistrict);
      setFormInquiryData((prevData) => ({
        ...prevData,
        district: districtId,
        city: "",
      }));

      setCityData([]); // Clear old city options

      fetchCityData(districtId); // Fetch new city list
    }
  };

  const handleCityChange = (selectedCity) => {
    if (selectedCity) {
      setFormInquiryData((prev) => ({
        ...prev,
        city: selectedCity.value,
      }));
    }
  };

  const handleUserChange = (selectedCity) => {
    if (selectedCity) {
      setFormInquiryData((prev) => ({
        ...prev,
        assigned_to: selectedCity.value,
      }));
    }
  };
  const handleleadSourcesChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        lead_source: selected.value,
      }));
    }
  };

  const handleStatusChange = (selectedCity) => {
    if (selectedCity) {
      setFormInquiryData((prev) => ({
        ...prev,
        status: selectedCity.value,
      }));
    }
  };
  const handleLoanTypeChange = (selectedCity) => {
    if (selectedCity) {
      setFormInquiryData((prev) => ({
        ...prev,
        loan_type_id: selectedCity.value,
      }));
    }
  };

  const handleLeadPriorityChange = (selected) => {
    if (selected) {
      setFormInquiryData((prev) => ({
        ...prev,
        lead_priority: selected.value,
      }));
    }
  };

  const handleDecimalChange = (key, value) => {
    const regex = /^\d*\.?\d{0,2}$/;

    if (key === "loan_amount") {
      if (value === "" || regex.test(value)) {
        setFormInquiryData((prev) => ({
          ...prev,
          [key]: value,
        }));
      }
    } else {
      setFormInquiryData((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const fetchDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id); // Send ID in the form data

      const result = await fetchFormData(
        "get-lead-inquiry-by-id",
        formData,
        "POST"
      );

      if (result && result.data) {
        setFormInquiryData(result.data);
        setFormInquiryData(() => ({
          ...result.data,
          inquiry_date: YearformatDate(result.data.inquiry_date),
          converted_date: YearformatDate(result.data.converted_date),
        }));
        fetchDistrictData(result.data.state);
        fetchCityData(result.data.district);
      } else {
        console.warn("Bank data not found.");
        setFormInquiryData("");
      }
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      setFormInquiryData("");
    }
  };

  useEffect(() => {
    fetchAllData();

    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const fetchRole = async () => {
        try {
          const existingData = {
            role: "Admin",
          };
          setFormInquiryData(existingData.role);
        } catch (error) {
          console.error("Failed to fetch role:", error);
        }
      };
      fetchRole();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!formInquiryData.loan_type_id) {
      topTost({ title: "Inquiry Type is required", icon: "error" });
      return;
    }

    const formData = new FormData();
    formData.append("branchID", "1");
    formData.append("customer_name", formInquiryData.customer_name || "");
    formData.append("phone_number", formInquiryData.phone_number || "");
    formData.append("alternate_number", formInquiryData.alternate_number || "");
    formData.append("email", formInquiryData.email || "");
    formData.append("address", formInquiryData.address || "");
    formData.append("city", formInquiryData.city || "");
    formData.append("state", formInquiryData.state || "");
    formData.append("district", formInquiryData.district || "");
    formData.append("loan_type_id", formInquiryData.loan_type_id || "");
    formData.append("loan_amount", formInquiryData.loan_amount || "");
    formData.append("inquiry_date", formInquiryData.inquiry_date || "");
    formData.append("status", formInquiryData.status || "");
    formData.append("remarks", formInquiryData.remarks || "");
    formData.append("assigned_to", formInquiryData.assigned_to || "");
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    formData.append("refrence_name", formInquiryData.refrence_name || "");
    formData.append("refrence_mobile", formInquiryData.refrence_mobile || "");
    formData.append("lead_source", formInquiryData.lead_source || "");
    formData.append("lead_priority", formInquiryData.lead_priority || "");

    try {
      let res;
      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);

        // ✅ Edit logic
        res = await fetchFormData(`update-loan-inquiries`, formData, "POST");
        console.log("Updating loan inquiry:", id, formData);
      } else {
        // ✅ Create logic
        res = await fetchFormData("insert-loan-inquiries", formData, "POST");
        console.log("Creating new loan inquiry:", formData);
      }

      if (res && (res.code === 200 || res.code === 201)) {
        topTost({
          title: res.message || "Operation successful",
          icon: "success",
        });
        navigate(`/inquiry/inquiry-list?id=${M_id}`);
      } else if (res && res.code === 422) {
        topTost({
          title: res.message || "Validation error occurred",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTagChange = (selectedOptions) => {
    const values =
      selectedOptions?.map((option) => option.value).join(",") || "";
    setFormInquiryData((prev) => ({
      ...prev,
      PreferBank: values,
    }));
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <>
              <div className="mb-5 d-flex align-items-center justify-content-between">
                <h5 className="fw-bold mb-0 me-4">
                  <span className="d-block mb-2">
                    {id ? "Edit Inquiry:" : "Add Inquiry:"}
                  </span>
                </h5>
              </div>
              <form onSubmit={handleSubmit} className="row g-3">
                <div className="row">
                  <div className="col-lg-6">
                    <Input
                      label="Customer Name"
                      name="customer_name"
                      value={formInquiryData.customer_name}
                      onChange={handleChange}
                      placeholder="Customer Name"
                      icon="feather-user"
                      required
                    />
                  </div>
                  <div className="col-lg-6">
                    <Input
                      label="Phone Number"
                      name="phone_number"
                      value={formInquiryData.phone_number}
                      onChange={handleChange}
                      placeholder="Phone Number"
                      icon="feather-phone"
                      required
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <Input
                      label="Alternate Number"
                      name="alternate_number"
                      value={formInquiryData.alternate_number}
                      onChange={handleChange}
                      placeholder="Alternate Number"
                      icon="feather-phone"
                    />
                  </div>
                  <div className="col-lg-6">
                    <Input
                      label="Email"
                      name="email"
                      value={formInquiryData.email}
                      onChange={handleChange}
                      placeholder="Email"
                      icon="feather-mail"
                    />
                  </div>
                </div>
                <div className="row ">
                  <div className="col-md-2">
                    <label className="fw-semibold">
                      Inquiry Type: <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={LoanTypedata}
                      selectedOption={
                        LoanTypedata.find(
                          (opt) => opt.value === formInquiryData.loan_type_id
                        ) || null
                      }
                      defaultSelect={"Select Loan Type"}
                      onSelectOption={handleLoanTypeChange}
                      icon="feather-briefcase"
                      value={formInquiryData.loan_type_id}
                      required
                    />
                  </div>
                  <div className="col-lg-6">
                    <Input
                      label="Inquiry (Intrested) Amount"
                      name="loan_amount"
                      type="number"
                      value={formInquiryData.loan_amount}
                      onChange={handleDecimalChange}
                      placeholder="Inquiry Amount"
                      icon="feather-dollar-sign"
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <Input
                      label="Address"
                      name="address"
                      value={formInquiryData.address}
                      onChange={handleChange}
                      placeholder="Address"
                      icon="feather-map-pin"
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="fw-semibold">State:</label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={stateData}
                      selectedOption={
                        stateData.find(
                          (opt) => opt.value === formInquiryData.state
                        ) || null
                      }
                      defaultSelect={"Select State"}
                      onSelectOption={handleStateChange}
                      icon="feather-map-pin"
                      value={Number(formInquiryData.state)}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-2 mb-2">
                    <label className="fw-semibold">District:</label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={districtData}
                      selectedOption={
                        districtData.find(
                          (opt) => opt.value === formInquiryData.district
                        ) || null
                      }
                      defaultSelect={"Select District"}
                      onSelectOption={handleDistrictChange}
                      icon="feather-layers"
                      value={Number(formInquiryData.district)}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="fw-semibold">City:</label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={citydata}
                      selectedOption={
                        citydata.find(
                          (opt) => opt.value === formInquiryData.city
                        ) || null
                      }
                      defaultSelect={"Select City"}
                      onSelectOption={handleCityChange}
                      icon="feather-flag"
                      value={Number(formInquiryData.city)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <Input
                      label="Reference Name"
                      name="refrence_name"
                      value={formInquiryData.refrence_name}
                      onChange={handleChange}
                      placeholder="Reference Name"
                      icon="feather-user"
                    />
                  </div>
                  <div className="col-md-6">
                    <Input
                      label="Reference Mobile"
                      name="refrence_mobile"
                      value={formInquiryData.refrence_mobile}
                      onChange={handleChange}
                      placeholder="Reference Mobile"
                      icon="feather-phone"
                    />
                  </div>
                </div>
                <div className="row ">
                  <div className="col-lg-6">
                    <Input
                      label="Inquiry Date"
                      name="inquiry_date"
                      type="date"
                      value={formInquiryData.inquiry_date}
                      onChange={handleChange}
                      placeholder="Inquiry Date"
                      icon="feather-date"
                      min={id ? undefined : today}
                      max={id ? today : undefined}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="fw-semibold">Inquiry Source:</label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={lead_sourcedata}
                      selectedOption={
                        lead_sourcedata.find(
                          (opt) => opt.value === formInquiryData.lead_source
                        ) || null
                      }
                      defaultSelect={"Select Lead Source"}
                      onSelectOption={handleleadSourcesChange}
                      value={Number(formInquiryData.lead_source)}
                      icon="feather-user"
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-2">
                    <label className="fw-semibold">Assigned User:</label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={userData}
                      selectedOption={
                        userData.find(
                          (opt) =>
                            opt.value === Number(formInquiryData.assigned_to)
                        ) || null
                      }
                      defaultSelect="Select Assigned User"
                      onSelectOption={handleUserChange}
                      value={formInquiryData.assigned_to}
                      icon="feather-user"
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="fw-semibold py-2">
                      Inquiry Priority:
                    </label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={leadPriorityData}
                      selectedOption={
                        leadPriorityData.find(
                          (opt) =>
                            opt.value === String(formInquiryData.lead_priority)
                        ) || null
                      }
                      value={formInquiryData.lead_priority}
                      defaultSelect="Select inquiry Priority"
                      onSelectOption={handleLeadPriorityChange}
                      icon="feather-flag"
                    />
                  </div>
                </div>

                <div className="row mt">
                  <div className="col-lg-6">
                    <Input
                      label="Remarks"
                      name="remarks"
                      value={formInquiryData.remarks}
                      onChange={handleChange}
                      placeholder="Remarks"
                      icon="feather-type"
                    />
                  </div>
                  {/* {id && (
                      <>
                        <div className="col-md-2">
                          <label className="fw-semibold">Inquiry Stage:</label>
                        </div>
                        <div className="col-lg-4">
                          <SelectDropdown
                            options={statusData}
                            selectedOption={
                              statusData.find(
                                (opt) => opt.value === formInquiryData.status
                              ) || null
                            }
                            defaultSelect={"Select Inquiry Stage"}
                            onSelectOption={handleStatusChange}
                            icon="feather-settings"
                            value={formInquiryData.status}
                          />
                        </div>
                      </>
                    )} */}
                </div>
                <div className="row">
                  <div className="row"></div>
                </div>
                <div className="mt-5 customButton">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loan_InquiryCreate;
